import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messagesList", "input", "form"]

  connect() {
    this.scrollToBottom()
    this.observeMessages()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  observeMessages() {
    if (!this.hasMessagesListTarget) return

    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })

    this.observer.observe(this.messagesListTarget, {
      childList: true,
      subtree: true
    })
  }

  scrollToBottom() {
    if (!this.hasMessagesListTarget) return
    const el = this.messagesListTarget
    el.scrollTop = el.scrollHeight
  }

  submitOnEnter(event) {
    if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
      event.preventDefault()
      this.formTarget.requestSubmit()
    }
  }

  autoResize() {
    if (!this.hasInputTarget) return
    const textarea = this.inputTarget
    textarea.style.height = "auto"
    textarea.style.height = Math.min(textarea.scrollHeight, 150) + "px"
  }

  // Clear input after form submission
  formTargetConnected() {
    if (!this.hasFormTarget) return
    this.formTarget.addEventListener("turbo:submit-end", () => {
      if (this.hasInputTarget) {
        this.inputTarget.value = ""
        this.inputTarget.style.height = "auto"
      }
    })
  }
}
